"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Chat = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Chat = function Chat() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.654 11.437a4.371 4.371 0 01-4.367 4.375H5.46a3.272 3.272 0 00-2.348.93L.928 18.927a.535.535 0 01-.382.165.546.546 0 01-.546-.547V4.875A4.371 4.371 0 014.368.5h10.919a4.371 4.371 0 014.367 4.375v6.562zm2.184 2.187v-8.75A2.186 2.186 0 0124 7.063v15.891a.546.546 0 01-.546.547.535.535 0 01-.382-.164l-2.184-2.187a3.273 3.273 0 00-2.326-.963H6.552A2.186 2.186 0 014.367 18H17.47a4.371 4.371 0 004.368-4.375z",
    clipRule: "evenodd"
  });
};

exports.Chat = Chat;